import { render, staticRenderFns } from "./ConciergeServiceCreateDlg.vue?vue&type=template&id=4a2bcffc&scoped=true"
import script from "./ConciergeServiceCreateDlg.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeServiceCreateDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./ConciergeServiceCreateDlg.scss?vue&type=style&index=0&id=4a2bcffc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bcffc",
  null
  
)

export default component.exports